export default function Toggle({ status, className='',...props }) {
  return (
    <div className={`device-toggle ${status ? 'device-toggle--active' : 'device-toggle--inactive'} ${className}`}>
      <button {...props}
        className={`device-toggle__content`}
      ></button>
    </div>
  );
};